import { render, staticRenderFns } from "./HistorySort.vue?vue&type=template&id=d6529cee&"
import script from "./HistorySort.vue?vue&type=script&lang=js&"
export * from "./HistorySort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports